import React, { useEffect, useState } from 'react';
import { getSalesmen, createSalesman, updateSalesman } from '../lib/api';
import { UserCheck, Plus, Edit2, Search, X } from 'lucide-react';

export default function SalesmenPage() {
  const [salesmen, setSalesmen] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ salesman_name: '', mobile_number: '', email: '' });

  const load = () => {
    setLoading(true);
    getSalesmen({ search }).then(r => { setSalesmen(r.data.salesmen || []); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, [search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editItem) { await updateSalesman(editItem._id, form); } else { await createSalesman(form); }
      setShowForm(false); setEditItem(null); setForm({ salesman_name: '', mobile_number: '', email: '' }); load();
    } catch (e) { alert(e.response?.data?.detail || 'Error'); }
  };

  const startEdit = (s) => {
    setEditItem(s);
    setForm({ salesman_name: s.salesman_name, mobile_number: s.mobile_number || '', email: s.email || '' });
    setShowForm(true);
  };

  return (
    <div className="space-y-4" data-testid="salesmen-page">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold text-boss-text">Salesman Master</h1><p className="text-boss-text-muted text-sm">{salesmen.length} salesmen</p></div>
        <button onClick={() => { setShowForm(true); setEditItem(null); setForm({ salesman_name: '', mobile_number: '', email: '' }); }} className="flex items-center gap-2 px-4 py-2 bg-boss-violet text-white rounded-lg text-sm font-medium hover:bg-boss-violet-2" data-testid="add-salesman-btn"><Plus size={16} /> Add Salesman</button>
      </div>

      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-boss-text-muted" />
        <input type="text" placeholder="Search salesmen..." value={search} onChange={e => setSearch(e.target.value)} className="w-full pl-9 pr-4 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
      </div>

      {showForm && (
        <div className="bg-white rounded-xl p-6 shadow-sm border border-boss-border">
          <div className="flex items-center justify-between mb-4"><h3 className="font-semibold text-boss-text">{editItem ? 'Edit' : 'Add'} Salesman</h3><button onClick={() => setShowForm(false)}><X size={18} /></button></div>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input required placeholder="Salesman Name *" value={form.salesman_name} onChange={e => setForm(f => ({...f, salesman_name: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" data-testid="salesman-name-input" />
            <input placeholder="Mobile" value={form.mobile_number} onChange={e => setForm(f => ({...f, mobile_number: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
            <input placeholder="Email" value={form.email} onChange={e => setForm(f => ({...f, email: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
            <button type="submit" className="px-6 py-2 bg-boss-violet text-white rounded-lg text-sm font-medium hover:bg-boss-violet-2">{editItem ? 'Update' : 'Create'}</button>
          </form>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-boss-border overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-boss-surface-2"><th className="text-left py-3 px-4 font-medium text-boss-text-muted">Name</th><th className="text-left py-3 px-4 font-medium text-boss-text-muted">Mobile</th><th className="text-left py-3 px-4 font-medium text-boss-text-muted">Email</th><th className="text-center py-3 px-4 font-medium text-boss-text-muted">Status</th><th className="text-center py-3 px-4 font-medium text-boss-text-muted">Action</th></tr></thead>
          <tbody>
            {loading ? [...Array(3)].map((_, i) => <tr key={i}><td colSpan={5} className="py-3 px-4"><div className="h-4 bg-boss-surface-3 rounded animate-pulse" /></td></tr>) : salesmen.length === 0 ? (
              <tr><td colSpan={5} className="py-12 text-center text-boss-text-muted">No salesmen found</td></tr>
            ) : salesmen.map(s => (
              <tr key={s._id} className="border-b border-boss-border/50 hover:bg-boss-surface-2/50">
                <td className="py-2.5 px-4 font-medium">{s.salesman_name}</td>
                <td className="py-2.5 px-4 font-mono text-xs">{s.mobile_number || '---'}</td>
                <td className="py-2.5 px-4 text-xs">{s.email || '---'}</td>
                <td className="py-2.5 px-4 text-center"><span className={`inline-block px-2 py-0.5 rounded-full text-xs ${s.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>{s.is_active ? 'Active' : 'Inactive'}</span></td>
                <td className="py-2.5 px-4 text-center"><button onClick={() => startEdit(s)} className="text-boss-violet hover:underline"><Edit2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
